import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IInfoGroupFieldConfiguration, infoGroupFieldConfigurationsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const INFO_GROUP_FIELD_CONFIGURATION_MODULE = 'infoGroupFieldConfiguration';

const dataObjectModule = getDataObjectsModule<IInfoGroupFieldConfiguration>(infoGroupFieldConfigurationsManager);
const searchModule = getSearchModule<IInfoGroupFieldConfiguration>(infoGroupFieldConfigurationsManager);

const infoGroupFieldConfigurationModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(INFO_GROUP_FIELD_CONFIGURATION_MODULE, infoGroupFieldConfigurationModuleInstance);

export { INFO_GROUP_FIELD_CONFIGURATION_MODULE };
